import type { Locale, PresentingDbLocale, PresentingLocale } from './types';

export const DEFAULT_LOCALE: Locale = 'en';
export const LOCALES: Array<Locale> = ['en', 'pt-BR', 'es-ES', 'de-DE'];
export const PATH_LOCALES = ['en-US', 'pt-BR', 'es-ES', 'de-DE'];
export const DEFAULT_PATH_LOCALE = 'en-US';
/**
 * The locales that are released to the public in parts of the application thats not yet translated.
 * These locales are the ones that are available in the language selector.
 */
export const RELEASED_LOCALES: Array<Locale> = ['en', 'de-DE'];
export const USER_LOCALE_STORAGE_KEY = 'mm-user-locale';
export const LANGUAGE_SELECTOR_OPTIONS = {
  'en-US': 'English',
  'de-DE': 'German',
  'pt-BR': 'Portuguese (Brazil)',
  'es-ES': 'Spanish',
} as const;

export const PRESENTING_LOCALES_MAP: Record<
  PresentingDbLocale,
  PresentingLocale
> = {
  br: 'pt-BR',
  ca: 'ca-ES',
  cs: 'cs-CZ',
  cy: 'cy-GB',
  da: 'da-DK',
  de: 'de-DE',
  en: 'en',
  es: 'es-ES',
  et: 'et-EE',
  fi: 'fi-FI',
  fr: 'fr-FR',
  hi: 'hi-IN',
  hr: 'hr-HR',
  hu: 'hu-HU',
  id: 'id-ID',
  is: 'is-IS',
  it: 'it-IT',
  ja: 'ja-JA',
  lt: 'lt-LT',
  nl: 'nl-NL',
  no: 'no-NO',
  pa: 'pa-PK',
  pl: 'pl-PL',
  pt: 'pt-PT',
  ro: 'ro-RO',
  ru: 'ru-RU',
  sl: 'sl-SL',
  srl: 'sr-Latn-RS',
  sv: 'sv-SE',
  ta: 'ta-IN',
  tr: 'tr-TR',
  uk: 'uk-UA',
  zh: 'zh-CN',
  zhs: 'ch-Hans-ZN',
};
